<div fxLayout="column" style=" height:250px;" class="mat-elevation-z4">

  <div fxLayout="column" fxFlexFill style="padding:15px;">
    <div fxLayout="row" class="reportCardTitle">
      Αναφορές
    </div>

    <div fxLayout="column" style="width:100%;">
      <div style="width:100%; font-family: 'Century Gothic', sans-serif; font-size:14px;" fxFlex fxLayoutAlign="center center">Σύνολο αναφορών: &nbsp;<span style="font-size:18px; font-weight: 700;">{{reports.length}}</span></div>
      <div fxLayoutAlign="space-evenly" style="height:120px; margin-top:20px;">
        <div>
          <ngx-gauge
            size="150"
            [type]="gaugeType"
            [value]="getAcceptedNumber()"
            label="Αποδοχή"
            [thresholds]="threshold1"
            [max]="reports.length">
          </ngx-gauge>
        </div>

        <div style="height:100px;">
          <ngx-gauge
            size="150"
            [type]="gaugeType"
            [value]="getDeniedNumber()"
            label="Απόρριψη"
            [thresholds]="threshold2"
            [max]="reports.length">
          </ngx-gauge>
        </div>

        <div style="height:100px;">
          <ngx-gauge
            size="150"
            [type]="gaugeType"
            [value]="getNoResponseNumber()"
            label="Σε αναμονή"
            [thresholds]="threshold3"
            [max]="reports.length">
          </ngx-gauge>
        </div>
      </div>

    </div></div>


  <div fxFlexAlign="center stretch" fxLayoutAlign="end stretch">
    <button (click)="navigateToReports()" mat-raised-button style="width:100%; color:white; background-color: var(--primary);">Πλοήγηση στις αναφορές</button>
  </div>
</div>
